import { map } from 'rxjs';
import { get } from '@/shared/api/http';
import type { FlightCategory } from '@/shared/types';

interface BackendFlightCategory {
  id: number;
  code: string;
  name: string;
  name_en: string;
  description: string;
  order: number;
  max_altitude_m: number | null;
  min_mtom_kg: string | null;
  max_mtom_kg: string | null;
  requires_buffer_zone: boolean;
  buffer_altitude_ratio: number;
  requires_termination_zone: boolean;
  termination_ratio_altitude: number;
}

function mapCategory(c: BackendFlightCategory): FlightCategory {
  return {
    id: String(c.id),
    code: c.code,
    name: c.name,
    nameEn: c.name_en,
    description: c.description,
    order: c.order,
    maxAltitudeM: c.max_altitude_m,
    minMtomKg: c.min_mtom_kg != null ? Number(c.min_mtom_kg) : null,
    maxMtomKg: c.max_mtom_kg != null ? Number(c.max_mtom_kg) : null,
    requiresBufferZone: c.requires_buffer_zone,
    bufferAltitudeRatio: c.buffer_altitude_ratio,
    requiresTerminationZone: c.requires_termination_zone,
    terminationRatioAltitude: c.termination_ratio_altitude,
  };
}

export function getFlightCategories() {
  return get<BackendFlightCategory[]>('/api/v1/flights/categories/').pipe(
    map(categories => categories.map(mapCategory)),
  );
}
